export const TRANSLATE_INBOX_MAIN_HEADER = 'INBOX.LANDING.HEADER';
export const TRANSLATE_INBOX_MAIN_FOOTER = 'INBOX.LANDING.FOOTER';
